import { render, staticRenderFns } from "./OneTimeSettlementStatus.vue?vue&type=template&id=72029b43&scoped=true&"
import script from "./OneTimeSettlementStatus.vue?vue&type=script&lang=js&"
export * from "./OneTimeSettlementStatus.vue?vue&type=script&lang=js&"
import style0 from "./OneTimeSettlementStatus.vue?vue&type=style&index=0&id=72029b43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72029b43",
  null
  
)

export default component.exports